import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import StatusIcon from '../../common/StatusIcon';
import PopTipCDS from '../../coreDesignSystem/PopTipCDS';

const PopInfo = ({ title = '', variant = '', children, ...props }) => {
  return (
    <PopTipCDS
      title={
        <div className="flex items-center gap-4">
          {variant && <StatusIcon size={20} status={variant} />}
          <Typography variant="regular16">{title}</Typography>
        </div>
      }
      {...props}
    >
      {children}
    </PopTipCDS>
  );
};

PopInfo.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.oneOf(Object.values(StatusEnum)),
};

export default memo(PopInfo);
